import Form from 'components/Form';

import { Fragment, useState } from 'react';
import { Typography } from '@mui/material';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContent';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const InspectionItems = (props: Props) => {
  const { disabled, register } = props;

  const infos = [
    { title: '시술일자', value: 'procedure_date' },
    { title: '시술내용', value: 'procedure_content' },
  ];

  return (
    <Fragment>
      <SectionTitle title="시술 정보" />
      <RowContainer xs={11.5} sx={{ margin: '20px 0px 30px 0px' }}>
        {infos.map(({ title, value }) => {
          if (title === '시술일자') {
            return (
              <RowContent title={title} titleRatio={1.3} childrenRatio={10.2}>
                <Form.MuiTextField
                  type={'date'}
                  required={false}
                  disabled={disabled}
                  {...register(`${value}`)}
                />
              </RowContent>
            );
          }
          return (
            <RowContent title={title} titleRatio={1.3} childrenRatio={10.2}>
              <Form.MuiTextField
                required={false}
                disabled={disabled}
                multiline
                minRows={3}
                {...register(`${value}`)}
              />
            </RowContent>
          );
        })}
      </RowContainer>
      <Typography sx={{ margin: '20px 0 50px 30px', fontSize: '12px' }}>
        상기 법정대리인(보호자)은 위 환자가 시술을 하는 것에 동의하며, 시술한
        것에 대해서 이의를 제기하지 않겠습니다.
      </Typography>
    </Fragment>
  );
};

export default InspectionItems;
